import React from "react";

import VerticalSteps from "./verticalSteps";
const { Step, SubSection } = VerticalSteps;

import colors from "@src/common/colors";
const { darkBlue, black, white } = colors;

import Text from "@src/common/text";

import {
  BubbleIcon,
  STANDARD_BUBBLE_SIZE,
  SMALL_BUBBLE_SIZE
} from "./bubbleIcons";
const genBubbleFormatter = (
  {
    waitingColor = darkBlue,
    activeColor = darkBlue,
    completeColor = darkBlue,
    small,
    bullet,
    textType,
    textSize
  } = {}
) => ({ active, complete, index }) => {
  let color = waitingColor;
  if (active) {
    color = activeColor;
  } else if (complete) {
    color = completeColor;
  }

  return (
    <Text type={textType} size={textSize}>
      <BubbleIcon
        backgroundColor={complete || active ? color : white}
        textColor={complete || active ? white : black}
        borderColor={color}
        size={small ? SMALL_BUBBLE_SIZE : STANDARD_BUBBLE_SIZE}
        bullet={bullet === undefined ? index + 1 : bullet}
      />
    </Text>
  );
};

function WrappedStep(props = {}) {
  const {
    children,
    subStep: small,
    waitingColor,
    activeColor,
    completeColor,
    bullet,
    bulletTextType: textType,
    bulletTextSize: fontType,
    autoHideContent,
    ...rest
  } = props;

  const bubbleData = {
    small,
    waitingColor,
    activeColor,
    completeColor,
    textType,
    fontType
  };

  if (bullet !== undefined) {
    bubbleData.bullet = bullet;
  } else if (small) {
    bubbleData.bullet = "";
  }

  return (
    <Step
      iconRender={genBubbleFormatter(bubbleData)}
      showContent={props.active}
      {...rest}
    >
      {React.Children.map(children, (child, index) => {
        if (child.type && child.type.isSubSection) {
          return React.cloneElement(child, {
            autoHideContent
          });
        }

        return child;
      })}
    </Step>
  );
}
WrappedStep.isStep = true;

function WrappedSubSection(props = {}) {
  const { children, activeStep, autoHideContent, ...rest } = props;

  return (
    <SubSection {...rest}>
      {React.Children.map(children, (child, index) => {
        if (child.type && child.type.isStep) {
          return React.cloneElement(child, {
            subStep: true,
            active: activeStep === index,
            complete: activeStep > index,
            autoHideContent
          });
        }

        return child;
      })}
    </SubSection>
  );
}
WrappedSubSection.isSubSection = true;

export default function WrappedVerticalSteps(props = {}) {
  const { children, activeStep, autoHideContent, ...rest } = props;

  return (
    <VerticalSteps {...rest}>
      {React.Children.map(children, (child, index) => {
        if (child.type && child.type.isStep) {
          return React.cloneElement(child, {
            active: activeStep === index,
            complete: activeStep > index,
            autoHideContent
          });
        }

        return child;
      })}
    </VerticalSteps>
  );
}

WrappedVerticalSteps.Step = WrappedStep;
WrappedVerticalSteps.SubSection = WrappedSubSection;



// WEBPACK FOOTER //
// ./src/common/verticalSteps/wrappedVerticalSteps.js